<!-- Legacy routed dashboards (type from route data) keep their own title. The reporting embed
     passes [type] and already renders its own mine-page-header, so it drops this one (Figma 941-15898). -->
@if (!type) {
    <h1 class="mine-title-m">{{ title }}</h1>
}

<div class="looker__container">
    @if (error()) {
        <div class="looker__error">
            <p class="looker__error-text">{{ 'common.somethingWentWrong' | content }}</p>
            <button class="looker__error-retry" type="button" (click)="retry()">
                {{ 'common.retry' | content }}
            </button>
        </div>
    } @else {
        @if (loading()) {
            <div class="looker__loading">
                {{ 'common.loading' | content }}
            </div>
        }

        @if (engine() === 'looker' && url(); as url) {
            <iframe
                class="looker__iframe"
                [src]="url"
                [title]="title ?? ''"
                width="100%"
                frameborder="0"
                (load)="onIframeLoad()">
            </iframe>
        }
    }

    <div
        #supersetMount
        class="looker__superset"
        [class.looker__superset--hidden]="engine() !== 'superset' || error()"
        [style.height.px]="supersetHeight()">
    </div>
</div>
